import React from "react";
import { Redirect } from "react-router-dom";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import InputLabel from "@material-ui/core/InputLabel";

import Select from "@material-ui/core/Select";
import Input from "@material-ui/core/Input";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import ListItemText from "@material-ui/core/ListItemText";
import Checkbox from "@material-ui/core/Checkbox";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";

// core components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardFooter from "components/Card/CardFooter.jsx";

import FormControlLabel from "@material-ui/core/FormControlLabel";

import httpr from "lib/httpRequest";
import { BASE_URL, AUTH_OPTIONS } from "lib/config";
import memberValidation from "../../lib/validation/memberValidation";

import Snackbar from "components/Snackbar/Snackbar.jsx";

const styles = (theme) => ({
  //const styles = {
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
  },
  addMemberControler: {
    marginLeft: theme.spacing.unit + 10,
    marginRight: theme.spacing.unit + 10,
    transform: `translate(0,0)`,
  },
  checkBox: {
    marginLeft: 0,
    marginRight: 0,
    margin: 0,
    padding: 0,
    fontSize: "14px",
  },
  formControl: {
    width: "100%",
  },
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0",
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
  },
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

class AddMember extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      locations: this.props.locations,
      selectedLocIds: [],
      reports: this.props.reports,
      selectedReports: ["All"],
      allReportsSelected: true,
      admin: false,
      service: false,
      email: "",
      confirmEmail: "",
      password: "",
      confirmPassword: "",
      firstName: "",
      lastName: "",
      emailErr: false,
      pwErr: false,
      fNameErr: false,
      lNameErr: false,
      locErr: false,
      serviceLocErr: false,
      tc: false,
      msg: "",
    };
  }

  handleChanged = (event) => {
    if (event.target.name === "selectedReports") {
      if (
        event.target.value[event.target.value.length - 1] === "All" ||
        event.target.value.length === 0
      ) {
        this.setState({
          [event.target.name]: ["All"],
          allReportsSelected: true,
          tc: false,
        });
      } else {
        this.setState({
          [event.target.name]: event.target.value.filter(
            (selected) => selected !== "All"
          ),
          allReportsSelected: false,
          tc: false,
        });
      }
    } else {
      this.setState({ [event.target.name]: event.target.value, tc: false });
    }
  };

  handleCreateUser = () => {
    // reset any existing errors
    this.setState({
      emailErr: false,
      pwErr: false,
      fNameErr: false,
      lNameErr: false,
      locErr: false,
      serviceLocErr: false,
    });

    const validation = memberValidation(this.state, false);

    if (validation.error) {
      if (validation.errorType.length === 1) {
        this.showNotification(validation.msg, validation.errorType);
        this.setState({
          [validation.errorType[0]]: true,
        });
      } else {
        this.showNotification(validation.msg, validation.errorType);
        validation.errorType.map((error) => {
          this.setState({
            [error]: true,
          });
        });
      }
    } else {
      // validation succeeded, create member
      this.createMember();
    }
  };

  showNotification = (msg) => {
    this.setState({
      tc: true,
      msg,
    });
  };

  handleToggleAdmin = (name) => (event) => {
    const { admin } = this.state;

    this.setState({
      admin: !admin,
    });
  };

  handleToggleService = (name) => (event) => {
    const { service } = this.state;

    this.setState({
      service: !service,
    });
  };

  renderSelectedLocationValues = (event) => {
    const Locations = event;
    const { selectedLocIds } = this.state;
    let locNames = [];

    Locations.map((loc) => {
      if (selectedLocIds.indexOf(loc.LocationId) > -1) {
        locNames.push(loc.LocationName.replace(/_/g, " "));
      }
    });

    return locNames.join(", ");
  };

  renderSelectedReportValues = (event) => {
    if (this.state.allReportsSelected) {
      return "All";
    }
    const { selectedReports } = this.state;
    let reportNames = [];

    event.map((report) => {
      if (selectedReports.indexOf(report.ReportId) > -1) {
        reportNames.push(report.ReportName.replace(/_/g, " "));
      }
    });

    return reportNames.join(", ");
  };

  createMember = () => {
    const mem = this.state;
    // send appropriate location objects:
    const locationsToSend = this.props.locations.filter((location) =>
      this.state.selectedLocIds.includes(location.LocationId)
    );

    mem.locations = locationsToSend;

    if (mem.allReportsSelected) {
      // add all report ids to the selectedReports array
      mem.selectedReports = [];
      this.state.reports.map((report) => {
        mem.selectedReports.push(report.ReportId);
      });
    }

    const token = localStorage.getItem("token");
    const fetch = httpr(token);

    fetch
      .post(`${BASE_URL}/api/members/create`, mem)
      .then((response) => {
        this.props.showNotification(response.data.message);
      })
      .catch((error) => {
        this.showNotification(error.response.data.error);
      });
  };

  render() {
    const { classes, isService } = this.props;
    let allLocations = <div />;

    allLocations = this.props.locations.map((loc) => (
      <MenuItem key={loc.LocationId} value={loc.LocationId}>
        <Checkbox
          checked={this.state.selectedLocIds.indexOf(loc.LocationId) > -1}
        />
        <ListItemText
          primary={
            loc.OrganizationId === 0
              ? `${loc.LocationName.replace(/_/g, " ")} (Service)`
              : `${loc.LocationName.replace(/_/g, " ")}`
          }
        />
      </MenuItem>
    ));

    let allReports;
    let showProvisionalCredit = false;
    this.state.locations.map(location => {
      if (location.ProvisionalCredit == 1) {
        showProvisionalCredit = true;
      } 
    });
    if (showProvisionalCredit === true) {
      allReports = this.state.reports.map((report) => {
        return (
          <MenuItem key={report.ReportId} value={report.ReportId}>
            <Checkbox
              checked={this.state.selectedReports.indexOf(report.ReportId) > -1}
            />
            <ListItemText primary={`${report.ReportName.replace(/_/g, " ")} `} />
          </MenuItem>        
        )
      });
     } else { 
       //Hide provisional credit report     
      allReports = this.state.reports.map((report) => {
        if (report.ReportName != "Provisional_Credit") {
          return (
            <MenuItem key={report.ReportId} value={report.ReportId}>
              <Checkbox
                checked={this.state.selectedReports.indexOf(report.ReportId) > -1}
              />
              <ListItemText primary={`${report.ReportName.replace(/_/g, " ")} `} />
            </MenuItem>
          )
        }
      });
    };

    return (
      <div className={classes.addMemberControler}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color="success">
                <h4 className={classes.cardTitleWhite}>Create New User</h4>
              </CardHeader>
              <CardBody>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText="Email address"
                      id="email"
                      name="email"
                      error={this.state.emailErr}
                      onChange={this.handleChanged}
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText="Confirm Email address"
                      id="confirmEmail"
                      name="confirmEmail"
                      error={this.state.emailErr}
                      onChange={this.handleChanged}
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText="Password"
                      id="password"
                      name="password"
                      type="password"
                      error={this.state.pwErr}
                      onChange={this.handleChanged}
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText="Confirm Password"
                      id="confirmPassword"
                      name="confirmPassword"
                      error={this.state.pwErr}
                      type="password"
                      onChange={this.handleChanged}
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </GridItem>
                  <FormHelperText className={classes.helperText}>
                    * We recommend a password that is different from the one
                    used to access your email. *
                  </FormHelperText>
                </GridContainer>

                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText="First Name"
                      id="firstName"
                      name="firstName"
                      error={this.state.fNameErr}
                      onChange={this.handleChanged}
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText="Last Name"
                      id="lastName"
                      name="lastName"
                      error={this.state.lNameErr}
                      onChange={this.handleChanged}
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </GridItem>
                </GridContainer>

                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <FormControl className={classes.formControl}>
                      <InputLabel htmlFor="select-multiple-checkbox">
                        Select Locations
                      </InputLabel>
                      <Select
                        name="selectedLocIds"
                        multiple={true}
                        value={this.state.selectedLocIds}
                        input={<Input id="select-multiple-checkbox" />}
                        renderValue={() => {
                          return this.renderSelectedLocationValues(
                            this.props.locations
                          );
                        }}
                        onChange={this.handleChanged}
                        MenuProps={MenuProps}
                        error={this.state.locErr}
                      >
                        {allLocations}
                      </Select>
                    </FormControl>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <FormControl className={classes.formControl}>
                      <InputLabel htmlFor="select-multiple-reports">
                        Select Reports
                      </InputLabel>
                      <Select
                        name="selectedReports"
                        multiple={true}
                        value={this.state.selectedReports}
                        input={<Input id="select-multiple-reports" />}
                        renderValue={() => {
                          return this.renderSelectedReportValues(
                            this.state.reports
                          );
                        }}
                        onChange={this.handleChanged}
                        MenuProps={MenuProps}
                        error={this.state.locErr}
                      >
                        <MenuItem value={"All"}>
                          <Checkbox checked={this.state.allReportsSelected} />
                          <ListItemText primary={"All"} />
                        </MenuItem>
                        {allReports}
                      </Select>
                    </FormControl>
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.admin}
                          onChange={this.handleToggleAdmin("admin")}
                        />
                      }
                      label="Admin Access"
                    />
                    {isService && (
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={this.state.service}
                            onChange={this.handleToggleService("service")}
                          />
                        }
                        label="Service Member"
                      />
                    )}
                  </GridItem>
                </GridContainer>
              </CardBody>
              <CardFooter>
                <Button color="success" onClick={this.handleCreateUser}>
                  Create
                </Button>
                <Button color="transparent" onClick={this.props.handleClose}>
                  Cancel
                </Button>

                <Snackbar
                  place="tc"
                  color="danger"
                  icon={ErrorOutlineIcon}
                  message={this.state.msg}
                  open={this.state.tc}
                  closeNotification={() => this.setState({ tc: false })}
                  close
                />
              </CardFooter>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

export default withStyles(styles)(AddMember);



// WEBPACK FOOTER //
// ./src/components/Members/AddMember.jsx